import { createExpenseImage } from '../Services/ExpenseService';

export const uploadImages = async (fileUploads, expenseResponse, mode) => {
    const createExpenseImageData = [];
    // DATA FILEUPLOADS WAS NOT HAVING TABS REMOVED
    fileUploads.forEach(async (fileUpload, index) => {
        const expenseId =
            index == 0
                ? expenseResponse.id
                : mode === 'pending-cc'
                ? expenseResponse.splitPreCodedExpenses[index - 1].id
                : expenseResponse.splitExpenses[index - 1].id;

        // Helper function to create image data for a specific attachment type
        const createImageData = (files, existingFiles, isInternal = false) => {
            if (!files?.length && !existingFiles?.length) return null;

            const imgData = new FormData();
            imgData.append('Id', expenseId);
            imgData.append('IsPrecoded', mode === 'pending-cc');
            // Add IsInternal flag once for all files in this upload
            imgData.append('IsInternal', isInternal);

            if (files && files.length > 0) {
                if (Array.isArray(files)) {
                    files.forEach((file) => {
                        imgData.append('Images', file);
                    });
                } else {
                    imgData.append('Images', files);
                }
            }

            if (existingFiles && existingFiles.length > 0) {
                if (Array.isArray(existingFiles)) {
                    existingFiles.forEach((existingFile, fileIndex) => {
                        imgData.append(`OriginalImages[${fileIndex}].Id`, existingFile.id);
                        imgData.append(
                            `OriginalImages[${fileIndex}].Filename`,
                            existingFile.filename
                        );
                        imgData.append(
                            `OriginalImages[${fileIndex}].OriginalFilename`,
                            existingFile.originalFilename
                        );
                        imgData.append(
                            `OriginalImages[${fileIndex}].IsCombinedPdf`,
                            existingFile.isCombinedPdf
                        );
                        imgData.append(
                            `OriginalImages[${fileIndex}].IsInternal`,
                            existingFile.isInternal || false
                        );
                    });
                }
            }

            return imgData;
        };

        // Check if this is a payment request with categorized uploads
        if (mode === 'payment' && (fileUpload.invoice || fileUpload.internal)) {
            // Handle invoice attachments
            const invoiceData = createImageData(
                fileUpload.invoice?.newFiles,
                fileUpload.invoice?.existingFiles,
                false // invoice attachments are not internal
            );
            if (invoiceData) {
                createExpenseImageData.push(invoiceData);
            }

            // Handle internal attachments
            const internalData = createImageData(
                fileUpload.internal?.newFiles,
                fileUpload.internal?.existingFiles,
                true // internal attachments are internal
            );
            if (internalData) {
                createExpenseImageData.push(internalData);
            }
        } else {
            // Original handling for non-payment modes
            const imgData = createImageData(fileUpload.newFiles, fileUpload.existingFiles, false);
            if (imgData) {
                createExpenseImageData.push(imgData);
            }
        }
    });

    // Run the Images APIs in reverse order
    // This is done in case Existing Images are clones to new tab and then removed from parent tab
    // after the fact.  It could be possible that the Parent Image is deleted and now not available to
    // be copied to the child
    for (let i = createExpenseImageData.length - 1; i >= 0; i--) {
        await createExpenseImage(createExpenseImageData[i]);
    }
};

export default uploadImages;
